module.exports = __webpack_public_path__ + "media/images/landing/favicon-cef365df6d934aaafaa53408bd57863d.ico";